import React from 'react';
import PropTypes from 'prop-types';
import {
    Input,
    Radio,
    FormControlLabel,
    Icon,
    IconButton
} from 'components';
import styles from './RadioButtonBuilderOption.scss';

/**
 * this component is a class component because is used inside
 * react-draggable-list  https://github.com/StreakYC/react-draggable-list
 * and they ask for those components to be class components.
*/
class RadioButtonBuilderOption extends React.Component {
    render () {
        const {
            item: {
                id,
                text
            },
            commonProps: {
                onChange,
                onRemove,
                isDisabled
            },
            dragHandleProps,
            placeholder
        } = this.props;
        const handleChange = text => onChange(id, text);
        const handleRemove = () => onRemove(id);

        return (
            <FormControlLabel
                disabled
                control={<Radio />}
                className={styles.container}
                label={
                    <Input
                        autoFocus
                        disableUnderline
                        fullWidth
                        defaultValue={text}
                        disabled={isDisabled}
                        placeholder={placeholder}
                        className={styles.input}
                        inputProps={{'aria-label': text || placeholder}}
                        onChange={event => handleChange(event.target.value)}
                        endAdornment={
                            // TODO: Find an elegant way to extract this
                            <div className={styles.iconsContainer}>
                                <IconButton
                                    className={styles.trashIcon}
                                    onClick={handleRemove}
                                    disabled={isDisabled}
                                    color='secondary'
                                >
                                    <Icon name='ion-md-trash'
                                    />
                                </IconButton>

                                <IconButton
                                    disabled={isDisabled}
                                    className={styles.dragHandle}
                                    {...dragHandleProps}
                                >
                                    <Icon name='ion-md-menu' />
                                </IconButton>
                            </div>
                        }
                    />
                }
            />
        );
    }
}

RadioButtonBuilderOption.propTypes = {
    item: PropTypes.shape({
        id: PropTypes.string.isRequired,
        text: PropTypes.string
    }),
    commonProps: PropTypes.shape({
        onChange: PropTypes.func.isRequired,
        onRemove: PropTypes.func.isRequired,
        isDisabled: PropTypes.bool.isRequired
    }),
    dragHandleProps: PropTypes.object.isRequired,
    placeholder: PropTypes.string
};

RadioButtonBuilderOption.defaultProps = {
    item: {
        text: ''
    },
    placeholder: 'New item'
};

export default RadioButtonBuilderOption;
